const SEARCH_STATUS = {
  started: 'Popular',
  typing: 'Suggested',
  finished: 'Results',
}

export default SEARCH_STATUS
